import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  id: "vendor-assess-review-notes",
  class: "tw-flex tw-flex-col tw-gap-[20px]"
}
const _hoisted_2 = { class: "tw-flex tw-items-center tw-justify-between" }
const _hoisted_3 = { class: "tw-text-[20px] tw-text-[#211F58] tw-font-semibold" }
const _hoisted_4 = {
  key: 0,
  class: "custom-global-skeleton tw-bg-[#ffffff] tw-h-[220px] tw-w-[100%] tw-border tw-shadow-[0px_0px_4px_0px_rgba(0,0,0,0.05)] tw-p-5 tw-border-solid tw-border-[#EFF0F1] tw-rounded-[6px]"
}

import { getComponentUiText } from "@/utils/utilities";
import { ref, watch } from "vue";
import TextArea1 from "../common/textArea1.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'vendorAssessmentNote',
  props: {
  note: {
    type: String,
    default: "",
  },
  disable: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    required: false,
    default: getComponentUiText(
      "app-assessments-vendor-questions-note-title-1",
    ),
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:value", "update:blur"],
  setup(__props, { emit: emits }) {

const props = __props;





const notes = ref(props.note);

watch(
  () => props.note,
  (value) => {
    notes.value = value;
  },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(__props.title), 1)
    ]),
    _withDirectives(_createVNode(TextArea1, {
      id: "vendor-assessment-note-input",
      class: "tw-min-h-[220px] tw-text-[15px] tw-font-normal tw-color-[#231F20] !tw-font-Poppins !tw-p-[25px]",
      "class-name": '!tw-bg-white',
      "data-cy": "vendor-assessment-note-input",
      placeholder: 
        _unref(getComponentUiText)(
          'app-assessments-vendor-questions-note-placeholder-1',
        )
      ,
      "no-resize": true,
      value: notes.value,
      disabled: __props.disable,
      maxlength: "600",
      "onUpdate:value": _cache[0] || (_cache[0] = ($event) => (notes.value = $event)),
      onFocusout: _cache[1] || (_cache[1] = 
        () => {
          emits('update:value', notes.value);
          emits('update:blur', notes.value);
        }
      )
    }, null, 8, ["placeholder", "value", "disabled"]), [
      [_vShow, !__props.isLoading]
    ]),
    (__props.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4))
      : _createCommentVNode("", true)
  ]))
}
}

})